import { Box, Typography } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';

import ControlledCheckbox from '~components/Form/ControlledCheckbox';
import { ParameterHangup } from '~pages/SipConfiguration/domain';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function HangUpNode(props: ContactFlowNodeProps) {
  const form = useForm<ParameterHangup>({
    defaultValues: props.data.parameter.hangup,
  });
  return (
    <BaseNode
      {...props}
      title='Hang Up'
      parameterForm={form}
      renderParameterForm={(hangup) => (
        <Typography>Reason excluded: {hangup?.reasonExcluded ? 'Yes' : 'No'}</Typography>
      )}
      transformParameter={(hangup) => ({ hangup })}
      renderEditParameter={({ control }) => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}>
          <ControlledCheckbox control={control} name='reasonExcluded' label='Reason Excluded' defaultValue={false} />
        </Box>
      )}
    />
  );
}
